import { render, staticRenderFns } from "./officeDashboard.vue?vue&type=template&id=89c01a16&"
import script from "./officeDashboard.vue?vue&type=script&lang=js&"
export * from "./officeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./officeDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports